<app-aumico-layout [hideFooter]="true">
    <ng-container content>
        <div class="closing-workflow-page">
            <h1 class="page-title">{{'aumico_reports_tasks_and_closing_advertising_title' | i18next}}</h1>
            <p class="page-description" [innerHtml]=" 'aumico_reports_tasks_and_closing_advertising_description' | i18next"></p>

            <div class="cards-container">
                <div class="workflow-card">
                    <div class="image-wrapper">
                        <img src="assets/images/mandate-task.png" alt="Mandate & Task Management" />
                    </div>
                    <div class="card-content">
                        <h3>{{'aumico_reports_tasks_and_closing_advertising_mandate_management_title' | i18next}}</h3>
                        <p>
                            {{'aumico_reports_tasks_and_closing_advertising_mandate_management_description' | i18next}}
                        </p>
                    </div>
                </div>

                <div class="workflow-card">
                    <div class="image-wrapper">
                        <img src="assets/images/closing-workflow.png" alt="Closing Workflow" />
                    </div>
                    <div class="card-content">
                        <h3>{{'aumico_reports_tasks_and_closing_advertising_closing_workflow_title' | i18next}}</h3>
                        <p>{{'aumico_reports_tasks_and_closing_advertising_closing_workflow_description' | i18next}}</p>
                    </div>
                </div>
            </div>

            <ham-button *ngIf="!cpmmIsActive" (buttonClick)="upgrade()" type="submit">
                {{'aumico_reports_tasks_and_closing_advertising_upgrade_button' | i18next}}
            </ham-button>
            <ham-button *ngIf="cpmmIsActive" (buttonClick)="closeWelcomeAndStart()" type="submit">
                {{ 'aumico_reports_tasks_and_closing_start' | i18next}}
            </ham-button>
        </div>
    </ng-container>
</app-aumico-layout>
<app-loading-spinner [active]="isActivating"></app-loading-spinner>
<ham-modal
    class="upgrade-modal"
    *ngIf="showUpgradePopup"
    showCancelButton="true"
    showCloseIcon="true"
    (cancel)="cancelUpgradeRequest()"
    (save)="closeUpgradeRequest()"
    title="{{'aumico_reports_tasks_and_closing_upgrade_prompt' | i18next}}"
    saveText="{{'aumico_reports_tasks_and_closing_confirm_and_continue' | i18next}}"
    cancelText="{{'aumico_reports_tasks_and_closing_cancel' | i18next}}"
    variant="grayfooter"
>
    <p style="text-align: left">{{ 'aumico_reports_tasks_and_closing_upgrade_access_description' | i18next }}</p>
</ham-modal>
<ham-modal
    class="confirmation-modal"
    *ngIf="showWelcomePopup"
    showCancelButton="true"
    showCloseIcon="true"
    (cancel)="closeWelcome()"
    (save)="closeWelcomeAndStart()"
    title="{{'aumico_reports_tasks_and_closing_welcome_title' | i18next }}"
    saveText="{{'aumico_reports_tasks_and_closing_start' | i18next}}"
    cancelText="{{'aumico_reports_tasks_and_closing_cancel' | i18next}}"
    size="lg"
    variant="grayfooter"
>
    <div style="overflow: hidden">
        <img src="assets/images/projects-overview.png" alt="Overview" />
    </div>

    <p style="text-align: left; margin-top: 16px; white-space: pre-wrap;" [innerHTML]="'aumico_reports_tasks_and_closing_success_message' | i18next"></p>
</ham-modal>
